// extracted by mini-css-extract-plugin
export default {"wrapper":"UpdateUserModal_wrapper__U95qc","form":"UpdateUserModal_form__Ifc72","button-wrapper":"UpdateUserModal_button-wrapper__pTBXr","spinner":"UpdateUserModal_spinner__rTy6B"};